import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка заказчиков
    async getCustomers(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);

      if (data.town > 0) {
        params.set("town", data.town);
      }

      if (data.urflag) {
        params.set("urflag", data.urflag);
      }

      return await this.get(`customers?${params.toString()}${sorting}`);
    },
    // Получение заказчика по id
    async getCustomerById(id) {
      return await this.get(`customers/id/${id}`);
    },
    // Создание заказчика
    async postCustomer(data) {
      return await this.post('customers', data);
    },
    // Изменение заказчика
    async putCustomer(data) {
      return await this.put(`customers/${data.id}`, data);
    },
    // Удаление заказчика
    async deleteCustomer(data) {
      return await this.delete(`customers/${data.id}`, null);
    },
    // Получение заказчиков по запросу
    async getCustomersSearch(query) {
      const params = new URLSearchParams();
      params.set('query', query || '');

      return await this.get(`customers/search?${params.toString()}`);
    },

    // Получение контактов заказчика
    async getCustomerContactsById(id) {
      return await this.get(`customers/${id}/contacts`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/customers.js